export default "__VITE_ASSET__Blq7gRok__"